import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f0c8b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_form_clone",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "newTargetCloneModalRef",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-100 mw-lg-900px" }
const _hoisted_3 = { class: "modal-content mx-md-15" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy fs-3 text-primary" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-5 px-lg-7 mh-700px scroll-y bg-light" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-top table-row-bordered mb-0 fs-6 min-w-300px" }
const _hoisted_11 = { class: "fw-bold text-gray-600" }
const _hoisted_12 = {
  class: "text-muted ps-5 w-50",
  colspan: "1"
}
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_18 = { class: "d-block" }
const _hoisted_19 = { class: "required" }
const _hoisted_20 = { class: "fv-plugins-message-container text-start" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_23 = { class: "d-block" }
const _hoisted_24 = { class: "required" }
const _hoisted_25 = { class: "fv-plugins-message-container text-start" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_28 = { class: "d-block" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "fv-plugins-message-container text-start" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  class: "text-muted ps-5",
  colspan: "1"
}
const _hoisted_33 = { class: "d-block mb-2 mt-2" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_36 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_37 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_38 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}
const _hoisted_39 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_1",
  "aria-expanded": "true",
  "aria-controls": "kt_accordion_1_body_1"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-stars fs-4 text-primary" })
  ])
], -1))
const _hoisted_41 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse accor-body",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_42 = { class: "accordion-body" }
const _hoisted_43 = { class: "table-responsive" }
const _hoisted_44 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_45 = { class: "fw-bold text-muted" }
const _hoisted_46 = { class: "w-50px" }
const _hoisted_47 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_48 = ["checked"]
const _hoisted_49 = { class: "min-w-150px text-uppercase" }
const _hoisted_50 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_51 = ["checked", "onClick"]
const _hoisted_52 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_53 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_54 = {
  key: 1,
  class: "accordion-item"
}
const _hoisted_55 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}
const _hoisted_56 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_2",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_2"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3 fs-4 text-primary" })
  ])
], -1))
const _hoisted_58 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_59 = { class: "fv-help-block p-7" }
const _hoisted_60 = { role: "alert" }
const _hoisted_61 = {
  id: "kt_accordion_1_body_2",
  class: "accordion-collapse collapse accor-body",
  "aria-labelledby": "kt_accordion_1_header_2",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_62 = { class: "accordion-body" }
const _hoisted_63 = { class: "table-responsive" }
const _hoisted_64 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_65 = { class: "fw-bold text-muted" }
const _hoisted_66 = { class: "w-50px" }
const _hoisted_67 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_68 = ["checked"]
const _hoisted_69 = { class: "min-w-140px text-uppercase" }
const _hoisted_70 = { class: "min-w-150px text-uppercase" }
const _hoisted_71 = { class: "min-w-140px text-uppercase" }
const _hoisted_72 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_73 = ["checked", "onClick"]
const _hoisted_74 = { class: "text-dark text-hover-primary d-block fs-6" }
const _hoisted_75 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_76 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_77 = { class: "" }
const _hoisted_78 = { class: "text-dark text-hover-primary d-block fs-6" }
const _hoisted_79 = {
  key: 2,
  class: "accordion-item"
}
const _hoisted_80 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_4"
}
const _hoisted_81 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_4",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_4"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people fs-4 text-primary" })
  ])
], -1))
const _hoisted_83 = {
  id: "kt_accordion_1_body_4",
  class: "accordion-collapse collapse accor-body",
  "aria-labelledby": "kt_accordion_1_header_4",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_84 = { class: "accordion-body" }
const _hoisted_85 = { class: "table-responsive" }
const _hoisted_86 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_87 = { class: "fw-bold text-muted" }
const _hoisted_88 = { class: "w-50px" }
const _hoisted_89 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_90 = ["checked"]
const _hoisted_91 = { class: "min-w-150px text-uppercase" }
const _hoisted_92 = { class: "min-w-140px text-uppercase" }
const _hoisted_93 = { class: "text-gray-600" }
const _hoisted_94 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_95 = ["checked", "onClick"]
const _hoisted_96 = { class: "d-flex align-items-center" }
const _hoisted_97 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_98 = { class: "fs-base" }
const _hoisted_99 = { class: "fs-base" }
const _hoisted_100 = {
  key: 3,
  class: "accordion-item"
}
const _hoisted_101 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_5"
}
const _hoisted_102 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_5",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_5"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "las la-business-time fs-4 text-primary" })
  ])
], -1))
const _hoisted_104 = {
  id: "kt_accordion_1_body_5",
  class: "accordion-collapse collapse accor-body",
  "aria-labelledby": "kt_accordion_1_header_5",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_105 = { class: "accordion-body" }
const _hoisted_106 = { class: "table-responsive" }
const _hoisted_107 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_108 = { class: "fw-bold text-muted" }
const _hoisted_109 = { class: "w-50px" }
const _hoisted_110 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_111 = ["checked"]
const _hoisted_112 = { class: "min-w-150px text-uppercase" }
const _hoisted_113 = { class: "min-w-140px text-uppercase" }
const _hoisted_114 = { class: "min-w-150px text-uppercase" }
const _hoisted_115 = { class: "min-w-150px text-uppercase" }
const _hoisted_116 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_117 = ["checked", "onClick"]
const _hoisted_118 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_119 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_120 = { class: "text-dark text-hover-primary" }
const _hoisted_121 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_122 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_123 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_124 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_125 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_126 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
}
const _hoisted_127 = { class: "indicator-label" }
const _hoisted_128 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_modal_new_target_form",
          onSubmit: _ctx.submitCloneData,
          ref: "cloneFormRef",
          class: "form",
          "validation-schema": _ctx.cloneFormData.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.clone")) + " - " + _toDisplayString(_ctx.formObj?.name), 1)
              ]),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"]))
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("tbody", _hoisted_11, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("common.name")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "name",
                          placeholder: "",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['name'],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cloneTargetData['name']) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ErrorMessage, { name: "name" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("pages.form.category")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "categories",
                          modelValue: _ctx.cloneTargetData['categoryCode'],
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cloneTargetData['categoryCode']) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_VZMultiSelect, _mergeProps(field, {
                              modelValue: _ctx.cloneTargetData['categories'],
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cloneTargetData['categories']) = $event)),
                              element: {
                            options: _ctx.categories,
                            multiSelect: true,
                            placeholder: 'Please select category',
                          }
                            }), null, 16, ["modelValue", "element"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_ErrorMessage, { name: "categories" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("common.startDate")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "startDate",
                          modelValue: _ctx.formObj['startDate'],
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formObj['startDate']) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps(field, {
                              placeholder: _ctx.t('common.selectDate'),
                              modelValue: _ctx.formObj['startDate'],
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formObj['startDate']) = $event)),
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              autoApply: true,
                              "model-type": "yyyy-MM-dd",
                              teleport: "body",
                              class: "w-100"
                            }), null, 16, ["placeholder", "modelValue", "format"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_ErrorMessage, { name: "startDate" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("common.endDate")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "endDate",
                          modelValue: _ctx.formObj['endDate'],
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formObj['endDate']) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps(field, {
                              placeholder: _ctx.t('common.selectDate'),
                              modelValue: _ctx.formObj['endDate'],
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formObj['endDate']) = $event)),
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              autoApply: true,
                              "min-date": _ctx.minEndDate,
                              "model-type": "yyyy-MM-dd",
                              teleport: "body",
                              class: "w-100"
                            }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_ErrorMessage, { name: "endDate" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("pages.user.form.locationRestrict")), 1),
                          _createVNode(_component_Field, {
                            name: "locationRestrict",
                            type: "checkbox",
                            value: "",
                            class: "form-check-input margin-left",
                            style: {"transform":"scale(0.8)"},
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (
                            _ctx.cloneTargetData['locationRestrict'] =
                              !_ctx.cloneTargetData['locationRestrict']
                          ))
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          (_ctx.cloneFormData?.cloneSections?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("h2", _hoisted_38, [
                                  _createElementVNode("button", _hoisted_39, [
                                    _hoisted_40,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.sections")), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("table", _hoisted_44, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_45, [
                                            _createElementVNode("th", _hoisted_46, [
                                              _createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  checked: 
                                              _ctx.cloneTargetData?.cloneSections
                                                ?.length > 0 &&
                                              _ctx.cloneTargetData?.cloneSections
                                                ?.length ==
                                                _ctx.cloneFormData?.cloneSections
                                                  ?.length
                                            ,
                                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (
                                              _ctx.selectAll($event, 'cloneSections')
                                            )),
                                                  value: ""
                                                }, null, 8, _hoisted_48)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.t("pages.form.sectionName")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneFormData.cloneSections, (section, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_50, [
                                                  _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "form-check-input",
                                                    value: "",
                                                    checked: 
                                                _ctx.isChecked(
                                                  'cloneSections',
                                                  section.formSectionId
                                                )
                                              ,
                                                    onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  section.formSectionId,
                                                  'cloneSections'
                                                )
                                              )
                                                  }, null, 8, _hoisted_51)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_52, [
                                                  _createElementVNode("span", _hoisted_53, _toDisplayString(section.sectionName) + "[" + _toDisplayString(section?.locationName ?? "") + "]", 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.cloneFormData?.cloneSites?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createElementVNode("h2", _hoisted_55, [
                                  _createElementVNode("button", _hoisted_56, [
                                    _hoisted_57,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.sites")) + " ", 1),
                                    (_ctx.siteValidation)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                          _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.t("validation.siteValidation")), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("table", _hoisted_64, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_65, [
                                            _createElementVNode("th", _hoisted_66, [
                                              _createElementVNode("div", _hoisted_67, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  checked: 
                                              _ctx.cloneTargetData?.cloneSites
                                                ?.length > 0 &&
                                              _ctx.cloneTargetData?.cloneSites
                                                ?.length ==
                                                _ctx.cloneFormData?.cloneSites
                                                  ?.length
                                            ,
                                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (
                                              _ctx.selectAll($event, 'cloneSites')
                                            ))
                                                }, null, 8, _hoisted_68)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.t("pages.form.clone.siteNumber")), 1),
                                            _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.t("pages.form.clone.siteName")), 1),
                                            _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.t("common.siteAddress")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneFormData.cloneSites, (site, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_72, [
                                                  _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "form-check-input",
                                                    value: "",
                                                    checked: 
                                                _ctx.isChecked(
                                                  'cloneSites',
                                                  site.webId
                                                )
                                              ,
                                                    onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  site.webId,
                                                  'cloneSites'
                                                )
                                              )
                                                  }, null, 8, _hoisted_73)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_74, _toDisplayString(site.code), 1)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_75, [
                                                  _createElementVNode("span", _hoisted_76, _toDisplayString(site.name), 1)
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_77, [
                                                _createElementVNode("span", _hoisted_78, _toDisplayString(site.siteAddress), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.cloneFormData?.cloneUsers?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createElementVNode("h2", _hoisted_80, [
                                  _createElementVNode("button", _hoisted_81, [
                                    _hoisted_82,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.usersRoles")), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("table", _hoisted_86, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_87, [
                                            _createElementVNode("th", _hoisted_88, [
                                              _createElementVNode("div", _hoisted_89, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  checked: 
                                              _ctx.cloneTargetData?.cloneUsers
                                                ?.length > 0 &&
                                              _ctx.cloneTargetData?.cloneUsers
                                                ?.length ==
                                                _ctx.cloneFormData?.cloneUsers
                                                  ?.length
                                            ,
                                                  value: "",
                                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (
                                              _ctx.selectAll($event, 'cloneUsers')
                                            ))
                                                }, null, 8, _hoisted_90)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_91, _toDisplayString(_ctx.t("common.usersRoles")), 1),
                                            _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.t("common.siteName")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", _hoisted_93, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneFormData.cloneUsers, (user, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_94, [
                                                  _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "form-check-input",
                                                    value: "",
                                                    checked: 
                                                _ctx.isChecked(
                                                  'cloneUsers',
                                                  user.webId
                                                )
                                              ,
                                                    onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  user.webId,
                                                  'cloneUsers'
                                                )
                                              )
                                                  }, null, 8, _hoisted_95)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_96, [
                                                  _createElementVNode("div", _hoisted_97, [
                                                    _createElementVNode("span", _hoisted_98, _toDisplayString(user.assignment), 1)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_99, _toDisplayString(user.siteName), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.cloneFormData?.cloneEvents?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                _createElementVNode("h2", _hoisted_101, [
                                  _createElementVNode("button", _hoisted_102, [
                                    _hoisted_103,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.events")), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_104, [
                                  _createElementVNode("div", _hoisted_105, [
                                    _createElementVNode("div", _hoisted_106, [
                                      _createElementVNode("table", _hoisted_107, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_108, [
                                            _createElementVNode("th", _hoisted_109, [
                                              _createElementVNode("div", _hoisted_110, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  checked: 
                                              _ctx.cloneTargetData?.cloneEvents
                                                ?.length > 0 &&
                                              _ctx.cloneTargetData?.cloneEvents
                                                ?.length ==
                                                _ctx.cloneFormData?.cloneEvents
                                                  ?.length
                                            ,
                                                  value: "",
                                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (
                                              _ctx.selectAll($event, 'cloneEvents')
                                            ))
                                                }, null, 8, _hoisted_111)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_112, _toDisplayString(_ctx.t("pages.form.clone.eventName")), 1),
                                            _createElementVNode("th", _hoisted_113, _toDisplayString(_ctx.t("pages.form.clone.eventMode")), 1),
                                            _createElementVNode("th", _hoisted_114, _toDisplayString(_ctx.t("common.siteName")), 1),
                                            _createElementVNode("th", _hoisted_115, _toDisplayString(_ctx.t("common.users")) + "/" + _toDisplayString(_ctx.t("common.roles")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneFormData.cloneEvents, (event, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_116, [
                                                  _createElementVNode("input", {
                                                    type: "checkbox",
                                                    class: "form-check-input",
                                                    value: "",
                                                    checked: 
                                                _ctx.isChecked(
                                                  'cloneEvents',
                                                  event.eventId
                                                )
                                              ,
                                                    onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  event.eventId,
                                                  'cloneEvents'
                                                )
                                              )
                                                  }, null, 8, _hoisted_117)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_118, [
                                                  _createElementVNode("span", _hoisted_119, _toDisplayString(event.eventName), 1)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_120, _toDisplayString(event.eventSubType
                                                .toLowerCase()
                                                .replace(/_/g, " ")
                                                .replace(/\b\w/g, (c) =>
                                                  c.toUpperCase()
                                                )), 1)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_121, [
                                                  _createElementVNode("span", _hoisted_122, _toDisplayString(event.siteName), 1)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_123, [
                                                  _createElementVNode("span", _hoisted_124, _toDisplayString(event.assignment), 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("button", {
                type: "reset",
                id: "form_clone_cancel",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)))
              }, _toDisplayString(_ctx.t("common.close")), 1),
              _createElementVNode("button", _hoisted_126, [
                _createElementVNode("span", _hoisted_127, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.save")) + " ", 1),
                  _createElementVNode("span", _hoisted_128, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_129
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}